import React from 'react';
import { styled } from '@linaria/react';

import {
  DemoRadioControl,
  DemoSliderControl,
} from '@/components/Demo';

import FlexDemo from './FlexDemo';
import Output from './Output';

function ShrinkZero({ solvable }) {
  const [maxWidth, setMaxWidth] = React.useState(null);

  React.useEffect(() => {
    const maxAvailableWidth =
      document.documentElement.clientWidth - 32 - 16;

    if (maxAvailableWidth < 600) {
      setMaxWidth(maxAvailableWidth);
    } else {
      setMaxWidth(600);
    }
  }, []);

  let middleItemFlexBasis = maxWidth - 16 * 4 - 64;
  middleItemFlexBasis = Math.min(middleItemFlexBasis, 300);

  if (!maxWidth) {
    return null;
  }

  return (
    <FlexDemo
      initialValues={{
        '--direction': 'row',
        containerWidth: maxWidth,
        flexShrink: 1,
      }}
      centered={true}
      customGrid={{
        gridTemplateColumns: solvable ? '1fr 1fr' : '1fr',
      }}
      controls={[
        !!solvable && (
          <DemoRadioControl
            id="flexShrink"
            key="flexShrink"
            label="flex-shrink"
            options={[0, { label: '1 (default)', value: 1 }]}
            wrapperStyle={{
              width: 180,
              color: 'hsl(50deg 100% 65%)',
              fontWeight: 'var(--font-weight-medium)',
            }}
          />
        ),
        <DemoSliderControl
          id="containerWidth"
          key="containerWidth"
          label="Container width"
          min={148}
          max={maxWidth}
          wrapperStyle={{ width: 284 }}
          handleFocusColor="white"
        />,
      ]}
    >
      {({ containerWidth, flexShrink }) => (
        <Output
          state={{ '--gap': '16px' }}
          height={32 + 16 * 2}
          wrapperStyle={{
            width: containerWidth + 2 * 2 + 4 * 2,
            padding: 16,
          }}
        >
          <Item
            type="ball"
            primary={!!solvable}
            flexBasis={32}
            flexShrink={flexShrink}
            containerWidth={containerWidth}
          />
          <Item
            type="stretch"
            flexBasis={middleItemFlexBasis}
            containerWidth={containerWidth}
          />
          <Item
            type="ball"
            primary={!!solvable}
            flexBasis={32}
            flexShrink={flexShrink}
            containerWidth={containerWidth}
          />
        </Output>
      )}
    </FlexDemo>
  );
}

function Item({ primary, type, flexBasis, flexShrink }) {
  const Shape = primary ? PrimaryShape : BaseShape;

  return (
    <ItemOuterWrapper
      style={{
        flexGrow: type === 'stretch' ? 1 : undefined,
        flexBasis,
        flexShrink,
      }}
    >
      <Shape
        style={{
          borderRadius: type === 'ball' ? '50%' : '1000px',
        }}
      />
    </ItemOuterWrapper>
  );
}

const ItemOuterWrapper = styled.div``;

const BaseShape = styled.div`
  border: 2px solid var(--color-gray-500);
  background: var(--color-gray-100);
  height: 32px;
`;

const PrimaryShape = styled(BaseShape)`
  border-color: hsl(50deg 100% 90%);
  background: hsl(50deg 100% 50%);
`;

export default ShrinkZero;
